import axios from "axios";

export const FETCH_ROLE_REQUEST = 'FETCH_ROLE_REQUEST';
export const FETCH_ROLE_SUCCESS = 'FETCH_ROLE_SUCCESS';
export const FETCH_ROLE_FAILURE = 'FETCH_ROLE_FAILURE';

export const CREATE_ROLE_REQUEST = 'CREATE_ROLE_REQUEST';
export const CREATE_ROLE_SUCCESS = 'CREATE_ROLE_SUCCESS';
export const CREATE_ROLE_FAILURE = 'CREATE_ROLE_FAILURE';

export const UPDATE_ROLE_REQUEST = 'UPDATE_ROLE_REQUEST';
export const UPDATE_ROLE_SUCCESS = 'UPDATE_ROLE_SUCCESS';
export const UPDATE_ROLE_FAILURE = 'UPDATE_ROLE_FAILURE';

export const DELETE_ROLE_REQUEST = 'DELETE_ROLE_REQUEST';
export const DELETE_ROLE_SUCCESS = 'DELETE_ROLE_SUCCESS';
export const DELETE_ROLE_FAILURE = 'DELETE_ROLE_FAILURE';

export const fetchRoleRequest = () => {
    return {
        type: FETCH_ROLE_REQUEST,
    }
}

export const fetchRoleSuccess = (Role) => {
    return {
        type: FETCH_ROLE_SUCCESS,
        payload: Role,
    }
}

export const fetchRoleFailure = (error) => {
    return {
        type: FETCH_ROLE_FAILURE,
        payload: error,
    }
}

export const createRoleRequest = () => {
    return {
        type: CREATE_ROLE_REQUEST,
    }
}

export const createRoleSuccess = (Role) => {
    return {
        type: CREATE_ROLE_SUCCESS,
        payload: Role
    }
}

export const createRoleFailure = (error) => {
    return {
        type: CREATE_ROLE_FAILURE,
        payload: error,
    }
}

export const updateRoleRequest = () => {
    return {
        type: UPDATE_ROLE_REQUEST,
    }
}

export const updateRoleSuccess = (updatedCompanie) => {
    return {
        type: UPDATE_ROLE_SUCCESS,
        payload: updatedCompanie
    }
}

export const updateRoleFailure = (error) => {
    return {
        type: UPDATE_ROLE_FAILURE,
        payload: error
    }
}

export const deleteRoleRequest = () => {
    return {
        type: DELETE_ROLE_REQUEST,
    }
}

export const deleteRoleSuccess = (pk) => {
    return {
        type: DELETE_ROLE_SUCCESS,

    }
}

export const deleteRoleFailure = (error) => {
    return {
        type: DELETE_ROLE_FAILURE,
        payload: error
    }
}

export const fetchAllRole = () => {
    return async (dispatch) => {
        dispatch(fetchRoleRequest);
        try {
            const responce = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/user-roles/`);
            dispatch(fetchRoleSuccess(responce.data))
        } catch (error) {
            dispatch(fetchRoleFailure(error))
            console.log(error);
        }
    }
}

export const createNewRole = (newCompanie) => {
    return async (dispatch) => {
        dispatch(createRoleRequest);
        try {
            const responce = axios.post(`${process.env.REACT_APP_BACKEND_URL}/create-role/`, newCompanie);
            dispatch(createRoleSuccess(responce.data))
        } catch (error) {
            console.log("redux responce", error);
            dispatch(createRoleFailure(error))
        }
    }
}

export const updateRoleData = (pk, updatedCompanie) => {
    return async (dispatch) => {
        dispatch(updateRoleRequest);
        try {
            const responce = axios.put(`${process.env.REACT_APP_BACKEND_URL}/companies/update/${pk}/`, updatedCompanie);
            dispatch(updateRoleSuccess(responce.data))
        } catch (error) {

        }
    }
}

export const c = (pk) => {
    return async (dispatch) => {
        dispatch(deleteRoleRequest);
        try {
            const responce = axios.delete(`${process.env.REACT_APP_BACKEND_URL}/companies/delete/${pk}/`);
            dispatch(deleteRoleSuccess(pk));
        } catch (error) {
            dispatch(deleteRoleFailure);
        }
    }
}



